module.exports = __webpack_public_path__ + "media/public/images/bg-waves-11ab0459fc98c59a52ac642edd1eb08b.svg";